export interface Replay {
  id: string;
  matchId: string;
  title: string;
  leagueKey: string;
  leagueName: string;
  date: string;
  duration: string;
  plays: string;
  home: string;
  away: string;
  score: string;
  cover: string;
}

export const replays: Replay[] = [
  {
    id: "r1",
    matchId: "m8",
    title: "英超第27轮 利物浦 vs 曼联 全场回放",
    leagueKey: "premier-league",
    leagueName: "英超",
    date: "2026-10-14",
    duration: "98:12",
    plays: "42.6万",
    home: "利物浦",
    away: "曼联",
    score: "3 - 0",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20with%20red%20and%20green%20tones%20under%20night%20floodlights%2C%20cinematic%20sport%20photography%20style%2C%20dramatic%20atmosphere%2C%20soft%20haze&width=640&height=360&seq=replay-r1-01&orientation=landscape",
  },
  {
    id: "r2",
    matchId: "m13",
    title: "欧冠小组赛 巴塞罗那 vs 多特蒙德 全场回放",
    leagueKey: "champions-league",
    leagueName: "欧冠",
    date: "2026-10-13",
    duration: "96:40",
    plays: "37.9万",
    home: "巴塞罗那",
    away: "多特蒙德",
    score: "4 - 1",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20large%20football%20stadium%20at%20night%20with%20bright%20lights%20and%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20deep%20green%20tones%2C%20atmospheric%20haze&width=640&height=360&seq=replay-r2-01&orientation=landscape",
  },
  {
    id: "r3",
    matchId: "m9",
    title: "西甲第25轮 马竞 vs 塞维利亚 全场回放",
    leagueKey: "la-liga",
    leagueName: "西甲",
    date: "2026-10-14",
    duration: "94:05",
    plays: "21.3万",
    home: "马德里竞技",
    away: "塞维利亚",
    score: "2 - 2",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20pitch%20at%20evening%20with%20warm%20lights%20and%20green%20grass%2C%20cinematic%20sport%20photography%20style%2C%20soft%20haze%2C%20harmonious%20tones&width=640&height=360&seq=replay-r3-01&orientation=landscape",
  },
  {
    id: "r4",
    matchId: "m10",
    title: "中超第21轮 北京国安 vs 上海申花 全场回放",
    leagueKey: "csl",
    leagueName: "中超",
    date: "2026-10-14",
    duration: "95:30",
    plays: "18.7万",
    home: "北京国安",
    away: "上海申花",
    score: "1 - 0",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20modern%20football%20stadium%20with%20evening%20lights%20and%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20cool%20teal%20tones%2C%20soft%20mist&width=640&height=360&seq=replay-r4-01&orientation=landscape",
  },
  {
    id: "r5",
    matchId: "m11",
    title: "英超第27轮 热刺 vs 纽卡斯尔 全场回放",
    leagueKey: "premier-league",
    leagueName: "英超",
    date: "2026-10-13",
    duration: "93:18",
    plays: "26.1万",
    home: "热刺",
    away: "纽卡斯尔",
    score: "1 - 1",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20football%20stadium%20at%20night%20with%20white%20and%20green%20tones%20under%20floodlights%2C%20cinematic%20sport%20photography%20style%2C%20atmospheric%20haze&width=640&height=360&seq=replay-r5-01&orientation=landscape",
  },
  {
    id: "r6",
    matchId: "m1",
    title: "英超第28轮 曼城 vs 利物浦 上半场集锦",
    leagueKey: "premier-league",
    leagueName: "英超",
    date: "2026-10-15",
    duration: "12:04",
    plays: "9.8万",
    home: "曼城",
    away: "利物浦",
    score: "—",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20dramatic%20football%20stadium%20at%20night%20with%20bright%20floodlights%20and%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20dark%20green%20tones%2C%20atmospheric%20mist&width=640&height=360&seq=replay-r6-01&orientation=landscape",
  },
  {
    id: "r7",
    matchId: "m3",
    title: "欧冠16强 拜仁 vs 巴黎 进球大战集锦",
    leagueKey: "champions-league",
    leagueName: "欧冠",
    date: "2026-10-15",
    duration: "08:42",
    plays: "11.2万",
    home: "拜仁慕尼黑",
    away: "巴黎圣日耳曼",
    score: "—",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20grand%20football%20stadium%20under%20bright%20spotlights%20with%20electric%20green%20pitch%2C%20cinematic%20sport%20photography%20style%2C%20deep%20emerald%20and%20gold%20tones&width=640&height=360&seq=replay-r7-01&orientation=landscape",
  },
  {
    id: "r8",
    matchId: "m2",
    title: "西甲国家德比 皇马 vs 巴萨 上半场回放",
    leagueKey: "la-liga",
    leagueName: "西甲",
    date: "2026-10-15",
    duration: "47:00",
    plays: "7.4万",
    home: "皇家马德里",
    away: "巴塞罗那",
    score: "—",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20packed%20football%20stadium%20at%20dusk%20with%20golden%20light%20beams%20and%20green%20field%2C%20cinematic%20sport%20photography%20style%2C%20warm%20orange%20tones&width=640&height=360&seq=replay-r8-01&orientation=landscape",
  },
];